import { useState } from 'react';

const Pen = ({ width, height, color = '#000000' }) => {
	const [isHovering, setIsHovering] = useState(false);

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width={width}
			zoomAndPan="magnify"
			viewBox="0 0 750 749.999995"
			height={height}
			preserveAspectRatio="xMidYMid meet"
			version="1.0"
			className={`border border-primary rounded-full transition duration-300 hover:bg-primary`}
			onMouseEnter={() => setIsHovering(true)}
			onMouseLeave={() => setIsHovering(false)}
		>
			<defs>
				<clipPath id="f2bf7df7b9">
					<path d="M 225 231.25 L 515 231.25 L 515 509 L 225 509 Z M 225 231.25 " clipRule="nonzero" />
				</clipPath>
			</defs>
			<g clipPath="url(#f2bf7df7b9)">
				<path
					strokeLinecap="round"
					transform="matrix(12.49983, 0, 0, 12.48913, 225.002027, 231.250014)"
					fill="none"
					strokeLinejoin="round"
					d="M 12.858138 4.226174 L 16.245997 0.999931 L 22.17514 6.645778 L 18.786969 9.872021 M 12.858138 4.226174 L 1.350794 15.183828 C 1.126103 15.397451 0.999851 15.687703 0.999851 15.990154 L 0.999851 21.163715 L 6.432738 21.163715 C 6.750555 21.163715 7.055247 21.043611 7.279937 20.829362 L 18.786969 9.872021 M 12.858138 4.226174 L 18.786969 9.872021 "
					stroke={isHovering ? 'white' : color}
					strokeWidth="2"
					strokeOpacity="1"
					strokeMiterlimit="4"
				/>
			</g>
		</svg>
	);
};

export default Pen;
